import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';
export function ContactPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-350">
      <Header data-id="element-351" />

      <main className="flex-grow" data-id="element-352">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-purple-50 to-teal-50 py-16 md:py-24" data-id="element-353">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-354">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-355">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-356">
              Ready to start your custom order? Have questions about our
              services? We're here to help bring your ideas to life.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24" data-id="element-357">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-358">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-359">
              {/* Contact Info */}
              <div data-id="element-360">
                <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-361">
                  Contact Information
                </h2>

                <div className="space-y-8" data-id="element-362">
                  <div className="flex items-start space-x-4" data-id="element-363">
                    <div className="bg-teal-100 p-3 rounded-full" data-id="element-364">
                      <Phone className="h-6 w-6 text-teal-600" data-id="element-365" />
                    </div>
                    <div data-id="element-366">
                      <h3 className="font-semibold text-gray-900" data-id="element-367">Call Us</h3>
                      <p className="text-gray-600 mt-1" data-id="element-368">
                        <a href="tel:9045210580" className="hover:text-purple-600 transition-colors" data-id="element-369">
                          (904) 521-0580
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4" data-id="element-370">
                    <div className="bg-purple-100 p-3 rounded-full" data-id="element-371">
                      <Mail className="h-6 w-6 text-purple-600" data-id="element-372" />
                    </div>
                    <div data-id="element-373">
                      <h3 className="font-semibold text-gray-900" data-id="element-374">Email Us</h3>
                      <p className="text-gray-600 mt-1" data-id="element-375">
                        <a href="mailto:info@teamsntees.com" className="hover:text-purple-600 transition-colors" data-id="element-376">
                          info@teamsntees.com
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4" data-id="element-377">
                    <div className="bg-teal-100 p-3 rounded-full" data-id="element-378">
                      <Clock className="h-6 w-6 text-teal-600" data-id="element-379" />
                    </div>
                    <div data-id="element-380">
                      <h3 className="font-semibold text-gray-900" data-id="element-381">
                        Business Hours
                      </h3>
                      <p className="text-gray-600 mt-1" data-id="element-382">
                        Monday - Friday: 9:00 AM - 5:00 PM
                        <br data-id="element-383" />
                        Saturday - Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-12" data-id="element-384">
                  <h3 className="font-semibold text-gray-900 mb-4" data-id="element-385">
                    Follow Us
                  </h3>
                  <div className="flex space-x-4" data-id="element-386">
                    <a href="https://www.facebook.com/tntcustomtee/" target="_blank" rel="noopener noreferrer" className="bg-gray-100 p-3 rounded-full hover:bg-purple-100 hover:text-purple-600 transition-colors" data-id="element-387">
                      <Facebook className="h-6 w-6" data-id="element-388" />
                    </a>
                    <div className="bg-gray-100 p-3 rounded-full text-gray-400 cursor-not-allowed" data-id="element-389">
                      <Instagram className="h-6 w-6" data-id="element-390" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100" data-id="element-391">
                <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-392">
                  Send a Message
                </h2>
                <form className="space-y-6" data-id="element-393">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-394">
                    <div data-id="element-395">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-396">
                        Name
                      </label>
                      <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-397" />
                    </div>
                    <div data-id="element-398">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-399">
                        Email
                      </label>
                      <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-400" />
                    </div>
                  </div>

                  <div data-id="element-401">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-402">
                      Phone (Optional)
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all" placeholder="(555) 123-4567" data-id="element-403" />
                  </div>

                  <div data-id="element-404">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-405">
                      Message
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all" placeholder="Tell us about your project..." data-id="element-406"></textarea>
                  </div>

                  {/* Visual ReCAPTCHA Placeholder */}
                  <div className="bg-gray-50 border border-gray-200 rounded-md p-4 flex items-center justify-between max-w-[300px]" data-id="element-407">
                    <div className="flex items-center space-x-3" data-id="element-408">
                      <div className="w-6 h-6 border-2 border-gray-300 rounded bg-white" data-id="element-409"></div>
                      <span className="text-sm text-gray-600" data-id="element-410">
                        I'm not a robot
                      </span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-411">
                      <div className="w-8 h-8 rounded-full bg-blue-500 opacity-20 mb-1" data-id="element-412"></div>
                      <span className="text-[10px] text-gray-400" data-id="element-413">
                        reCAPTCHA
                      </span>
                    </div>
                  </div>

                  <button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-414">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-415" />
    </div>;
}